import { _get } from "../../http";

export const obtenerEstructuraYRelaciones = (tipoDeEstructura, estructuraId) =>
  _get(`/usuarios/info/obtenerPorIdEstructura/${tipoDeEstructura}/${estructuraId}`);
